/* eslint-disable @typescript-eslint/no-loss-of-precision */
export const submitConfigOptions = [
  {
    value: 'utility',
    label: 'Utility',
    children: [
      // {
      //   value: 'fuel',
      //   label: 'Fuel',
      //   children: [
      //     {
      //       value: 'byMachine',
      //       label: 'By Machine'
      //     },
      //     {
      //       value: 'byVehicle',
      //       label: 'By Vehicle'
      //     },
      //     {
      //       value: 'byRefri',
      //       label: 'By Refrigerant'
      //     }
      //   ]
      // },
      {
        value: 'electricity',
        label: 'Electricity',
        children: [
          {
            value: '66e956203def64db6dd9b761',
            label: 'Non Renewable'
          }
        ]
      }
      // {
      //   label: 'Water',
      //   value: 'water'
      // }
    ]
  },
  {label: 'Purchase Bill', value: 'purchase_bill'},
  {label: 'Utility Bill', value: 'utility_bill'},
  {label: 'Fuel Bill', value: 'fuel_bill'}
  // {
  //   label: 'Demo Purpose',
  //   value: 'a',
  //   children: [
  //     {
  //       value: '6720a4895d220685b565a734',
  //       label: 'Template 1'
  //     }
  //   ]
  // }
];
